import { generatePath } from "react-router-dom"

import { getSubRoutes } from "modules/PsyCatalog/common/utils"
import { ctx } from "modules/PsyCatalog/common/ctx"
import { formAtom } from "modules/PsyCatalog/common/models/filterForm"
import { UrlBuilder } from "modules/PsyCatalog/common/Filters/UrlBuilder"
import { citiesSlugsAtom } from "modules/PsyCatalog/common/models/cities"
import { methodsSlugsAtom } from "modules/PsyCatalog/common/models/methods"
import { competencesSlugsAtom } from "modules/PsyCatalog/common/models/competences"
import { CurrentFilter } from "modules/PsyCatalog/common/services/currentFilter"
import { isBrowser } from "utils/infrastructure/ssg-utils"

export interface UpdateUrl {
    run(): void
}

function run() {
    if (!isBrowser()) return
    const { routes, params } = getSubRoutes(location.pathname)
    const data = ctx.get(formAtom)
    const newParams: { "page(\\d+)": string | null; filter: string | null } = {
        "page(\\d+)": params && "page" in params ? String(params.page) : null,
        filter: params && "filter" in params ? String(params.filter) : null,
    }
    const builder = new UrlBuilder(
        generatePath(routes.path, newParams),
        CurrentFilter.get(),
        data,
        {
            cities: ctx.get(citiesSlugsAtom),
            methods: ctx.get(methodsSlugsAtom),
            competences: ctx.get(competencesSlugsAtom),
        }
    )
    window.history.pushState({}, "", builder.build())
}

export const UpdateUrl = {
    run,
}
